
(function($){
  var that = {};

  that.pollVotingHander = function () {
    var poll = $('#poll');
    var btn = poll.find(".wp-polls-ans button").first();
    if (btn.length) {
      var current_poll_id = btn.data('poll');
      var multipleEl = document.querySelector('#poll_multiple_ans_'+current_poll_id);
      var multiple = multipleEl ? multipleEl.value : 1;
      var clicked_polls = that.getPollCookie();

      // if only 1 answer possible
      if (clicked_polls && $.inArray(current_poll_id, clicked_polls) >= 0 && multiple === 1) {
        that.disablePoll();
      } else {
        var answercookie = that.getPollAnswerCookie();
        if(answercookie[current_poll_id]) {
          if(answercookie[current_poll_id].length >= multiple) {
            that.disablePoll();
          } else {
            jQuery.each(answercookie[current_poll_id], function(index, value){
              var el = $("#poll-answer-" + value);
              if (el.length) {
                el.addClass("disabled");
              }
            });
          }
        }
      }
    }

    poll.find('.wp-polls-ans button:not(disabled)').click(function (event) {
      event.preventDefault();

      if ($(this).hasClass('disabled')) {
        return false;
      }

      var current_poll_id = $(this).data('poll');
      var clicked_polls = that.getPollCookie();
      var is_clicked = false;
      var answerids = [];

      if(getLibObject("config").useNewPollPlugin) {
        var answers = document.querySelectorAll('[id^="poll-answer-"]');
        for(var i = 0; i < answers.length; i++) {
          answerids.push(answers[i].value);
        }
        if (clicked_polls) {
          var alreadyVotedPoll = $.inArray(current_poll_id, clicked_polls) >= 0;
          if (alreadyVotedPoll && multiple === 1) {
            is_clicked = true;
          } else {
            var answercookie = that.getPollAnswerCookie();
            if(answercookie[current_poll_id]) {
              if(answercookie[current_poll_id].length >= multiple) {
                is_clicked = true;
              }
            }
          }
        }
      } else {
        // old behaviour
        if (clicked_polls) {
          if ($.inArray(current_poll_id, clicked_polls) >= 0) {
            is_clicked = true;
          }
        }
      }

      getLibObject("config").poll_id = current_poll_id;
      getLibObject("config").poll_answer_id = $(this).val();

      if (!is_clicked) {

        if (getLibObject("config").poll_answer_id > 0) {
          //poll_nonce = $('#poll_' + window.poll_id + '_nonce').val();
          /*if (pollsL10n.show_fading) {
            $('#polls-' + getLibObject("config").poll_id).fadeTo('def', 0);
          }
          if (pollsL10n.show_loading) {
            $('#polls-' + getLibObject("config").poll_id + '-loading').show();
          }*/

          if(getLibObject("config").websocketSuccess) {
            // Daten aus dem Form laden
            var sendToNode = {
              blogId: sage_js.blog_id,
              pollId: getLibObject("config").poll_id,
              answerId: getLibObject("config").poll_answer_id,
              answerIds: answerids,
              multiple: multiple
            };

            getLibObject("websocket").socket.emit('frontend-poll-vote', sendToNode);
          }

        } else {
          getLibObject("helper").growlerror({message: "ungültige Antwort."});
          // disablePoll();
        }
      } else {
        getLibObject("helper").growlerror({message: "Sie haben bereits abgestimmt."});
        that.disablePoll();
      }
    });
  };

  that.disablePollFromWebsocket = function (answerIds) {
    var el_poll = $('#poll');
    var el;
    var answercookie = {};
    var pollid = getLibObject("config").poll_id;
    answercookie[pollid] = [];
    el_poll.find('.wp-polls-ans').addClass('disabled');
    el_poll.find('.wp-polls-ans .baloon').attr("disabled", true).addClass('disabled');

    jQuery.each(answerIds, function(index, value){
      el = $("#poll-answer-" + value);
      if (el.length) {
        el.removeClass("disabled");
      }

      answercookie[pollid].push(value);
    });

    that.setPollAnswerCookie(answercookie);
  };

  that.disablePoll = function () {
    var el_poll = $('#poll');
    var el;
    var pollanswers = that.getPollAnswerCookie();
    el_poll.find('.wp-polls-ans').addClass('disabled');
    el_poll.find('.wp-polls-ans .baloon').attr("disabled", true).addClass('disabled');

    jQuery.each(pollanswers, function(index, value){
      if(getLibObject("config").useNewPollPlugin) {
        if(typeof value !== 'string' && typeof value !== 'number') {
          for(var i=0; i<value.length; i++) {
            el = $("#poll-answer-" + value[i]);
            if (el.length) {
              el.removeClass("disabled");
            }
          }
        } else {
          el = $("#poll-answer-" + value);
          if (el.length) {
            el.removeClass("disabled");
          }
        }
      } else {
        // old behaviour
        el = $("#poll-answer-" + value);
        if(el.length) {
          el.removeClass("disabled");
        }
      }
    });
  };

  that.addIdToPollCookie = function () {
    var clicked_polls = that.getPollCookie();
    var poll_id = parseInt(getLibObject("config").poll_id);

    if (!clicked_polls) {
      clicked_polls = [];
    }

    if ($.inArray(poll_id, clicked_polls) === -1) {
      clicked_polls.push(parseInt(getLibObject("config").poll_id));
    }
    that.setPollCookie(clicked_polls);
  };

  that.setPollCookie = function (polls) {
    $.cookie('polls', JSON.stringify(polls), {expires: 0.2, path: "/"});
  };
  that.getPollCookie = function () {
    if (!$.cookie("polls")) {
      return false;
    }
    return JSON.parse($.cookie('polls'));
  };
  that.setPollAnswerCookie = function (pollanswers) {
    $.cookie('pollanswers', JSON.stringify(pollanswers), {expires: 0.2, path: "/"});
  };
  that.getPollAnswerCookie = function () {
    if (!$.cookie("pollanswers")) {
      return false;
    }
    return JSON.parse($.cookie('pollanswers'));
  };

  that.activatePollFromWebsocket = function(poll, answers) {
    var pollContent = '';
    var pHeader = getLibObject("config").ajax_templates.pollHeader;
    var pollHeader = pHeader.replaceAll("%%POLLID%%", poll.ID).replaceAll("%%POLLQUESTION%%", poll.post_title);
    pollContent += pollHeader;
    var answerids = Object.keys(answers);

    for(var i = 0; i < answerids.length; i++) {
      var acontent = getLibObject("config").ajax_templates.pollBody;
      var answercontent = acontent.replaceAll("%%POLLANSWERID%%", answerids[i]).replaceAll("%%POLLID%%", poll.ID).replaceAll("%%POLLANSWER%%", answers[answerids[i]]);
      pollContent += answercontent;
    }

    var pFooter = getLibObject("config").ajax_templates.pollFooter;
    var pollFooter = pFooter.replaceAll("%%POLLID%%", poll.ID).replaceAll("%%POLLMULTIPLE%%", poll.multiple);
    pollContent += pollFooter;

    $('#poll').empty().html(pollContent);
    getLibObject("poll").pollVotingHander();
    $('#player').addClass("poll-visible");
  };

  that.deactivatePollFromWebsocket = function() {
    $('#poll').empty();
    $('#player').removeClass("poll-visible");
  };

  that.changeCurrentPoll = function(poll) {
    $('.wp-polls').attr('id', 'polls-'+poll.pollId).empty().html('<p>'+poll.question+'</p>');
    $('.wp-polls-ans').attr('id', 'polls-'+poll.pollId+'-ans');
    var ul = $('.wp-polls-ans').find('ul');
    var answerscontent = '';
    var keys = Object.keys(poll.answers);

    for(var i = 0; i < keys.length; i++){
      var key = keys[i];
      var value = poll.answers[key];
      answerscontent += '<li id="answer-'+key+'">';
      answerscontent += '<p class="caption">'+value+'</p>';
      answerscontent += '<div class="pollbar" data-pollbarwidth="'+poll.answerpercentages[key]+'" style="width: 1%">';
      answerscontent += '<p class="percentage"></p>';
      answerscontent += '</div>';
      answerscontent += '</li>';
    }

    $(ul).empty().html(answerscontent);

    that.addPollResultClick();
  };

  that.addPollResultClick = function(){
    $("#poll-results").click(function(e){
      e.preventDefault();
      var that = $(this);
      that.find(".pollbar").each(function(){
        var percent = $(this).attr("data-pollbarwidth");
        $(this).animate({'width': percent+"%"});
        $(this).find(".percentage").text(percent+"%");
      });
      getLibObject("config").umfrage_bars_visible = true;
      $("#poll-results").off("click");
    });
  };

  that.fieldChangedMentimeterActive = function(value){
    if(value === '1') {
      that.activateMentimeterFromWebsocket();
    } else {
      that.deactivateMentimeterFromWebsocket();
    }
  };

  that.activateMentimeterFromWebsocket = function(){
    $('#player').addClass("poll-visible");
  };

  that.deactivateMentimeterFromWebsocket = function(){
    $('#player').removeClass("poll-visible");
  };

  that.fieldChangedMentimeterUrl = function(value){
    if($('#mentimeter').attr('src') !== value) {
      that.updateMentimeterUrl(value);
    }
  };

  that.updateMentimeterUrl = function(url) {
    var content = '<iframe id="mentimeter" src="'+url+'" width="100%" height="100%"></iframe>';
    $('#poll').empty().html(content);
  };

  window.vrnetworld.poll = that;
})(jQuery);
